import React, { Component } from 'react';

import GenerateQRCode from '../home/GenerateQRCode';
import DestinationSwitch from '../shared/DestinationSwitch';

class ArrivingOrLeavingComponent extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    direction: null
  }

  handleSubmit(event) {
    this.setState({direction: event.target.dataset.direction})
  }

  render() {
    const profile = this.props.profile

    if (this.state.direction) {
      return <DestinationSwitch current_page="arriving-or-leaving" profile={profile} direction={this.state.direction} />
    }

    return (
      <>
        <div className="widgets" style={{gridTemplateColumns: "auto auto", gridGap: "80px"}}>
          <div data-direction="arriving" className="widget button arriving-or-leaving" onClick={this.handleSubmit}>
            Arriving
          </div>

          <div data-direction="leaving" className="widget button arriving-or-leaving" onClick={this.handleSubmit}>
            Leaving
          </div>
        </div>

        {profile === undefined && (
          <div className="single-qr-container">
            Mobile Check in/out
            <GenerateQRCode />
          </div>
        )}
      </>
    )
  }
}

export default ArrivingOrLeavingComponent;
